export default __webpack_public_path__ + "8f08e84d2124ac567be43bf3f7e95f60.png";